/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/MassageGun/gunBottomCover.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation1.play();
    actions.Animation1.repetitions = 1;
    actions.Animation1.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="bottomCover" geometry={nodes.bottomCover.geometry} material={materials.材質} />
      </group>
    </group>
  )
}

useGLTF.preload('/MassageGun/gunBottomCover.glb')
